import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TopNavigationWidget: WidgetRegistryEntry = {
  name: "top-navigation",
  component: () => import("./top-navigation-widget.component").then((m) => m.TopNavigationWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.TopNavigationWidgetConfiguration)
};
